import { Button } from "@ariakit/react";
import { interactiveText } from "@indietabletop/appkit/common.css.ts";
import type { NameGenerator } from "../../engine/NameGenerator.ts";

export function GenerateNameHint(props: {
  onGenerate: (name: string) => void;
  generator: NameGenerator;
}) {
  const handleClick = () => {
    props.onGenerate(props.generator.generate());
  };

  return (
    <>
      {"Stuck? Generate a "}
      <Button className={interactiveText} onClick={handleClick}>
        random name
      </Button>
      {"!"}
    </>
  );
}
